import React from 'react';
import "./Auditoriums.css";
import AuditoriumOptions from "./AuditoriumOptions"

const Auditoriums = function (props) {
    return (       
        <React.Fragment>
                <div className="cardRoot">
                    <div className="auditoriumsImgPart">
                        <img className="imgAuditoriumsWebPart" src={props.data.MuseumAuditoriumImg_Url} data-holder-rendered="true"  alt={"תמונת "+ props.data.LinkTitle}/>
                    </div>
                    <div className="auditoriumInformation">
                        <div className= "auditoriumMainDivTitle">
                            <h2 className="auditoriumsSubTitle">{props.data.LinkTitle}</h2>       
                            <h2 className="auditoriumsSubTitle">{props.data.MuseumAuditoriumName}</h2>       
                        </div>
                        <div className= "infoTableDiv">
                            {props.data.MuseumAuditoriumSitting != null ?
                                <div className="seatingArrangmentDiv">
                                    <span>
                                        {props.data.MuseumAuditoriumSitting}
                                    </span>
                                </div> : null}
                            {props.data.MuseumAuditoriumOptions !=null ? 
                                <div className="museumAuditoriumOptions">
                                    <AuditoriumOptions items={props.data.MuseumAuditoriumOptions}/>
                                </div> : null}
                        </div>
                    </div>  
                </div>
            </React.Fragment>
    );
}

export default Auditoriums;
